<div class="ad-skin">
  <div *ngIf="adSkinProps$ | async as adSkinProps" class="d-none d-xl-block">
    <flo-lazy
      [componentConstructor]="AdComponent"
      [initialProps]="adSkinProps"
      (componentLoaded)="loadedAdsPush($event)"
    ></flo-lazy>
  </div>
</div>
<main *ngIf="video$ | async as video" class="pt-0 pt-sm-3">
  <span *ngIf="adInterstitialProps$ | async as adInterstitial">
    <flo-lazy
      [componentConstructor]="AdComponent"
      [initialProps]="adInterstitial"
      (componentLoaded)="loadedAdsPush($event)"
    ></flo-lazy>
  </span>
  <div *ngIf="adLeaderboardLarge$ | async as adLeaderboardLarge" class="mb-3 d-none d-lg-block">
    <flo-lazy
      class="leaderboard-center"
      [componentConstructor]="AdComponent"
      [initialProps]="adLeaderboardLarge"
      [detectorHeight]="90"
      [detectorWidth]="728"
      (componentLoaded)="loadedAdsPush($event)"
    ></flo-lazy>
  </div>
  <div *ngIf="adLeaderboardSmall$ | async as adLeaderboardSmall" class="mb-3 d-none d-md-block d-lg-none">
    <flo-lazy
      class="leaderboard-center"
      [componentConstructor]="AdComponent"
      [initialProps]="adLeaderboardSmall"
      [detectorHeight]="90"
      [detectorWidth]="728"
      (componentLoaded)="loadedAdsPush($event)"
    ></flo-lazy>
  </div>
  <div class="container right-rail">
    <div class="row main-row">
      <section id="content" class="col-12 col-lg-8 wrapper border-lg-right">
        <h1 data-test="video-title">{{ video.source.title }}</h1>
        <div *ngIf="!!video.primaryAssoc" data-test="primary-assoc" class="assoc-event">
          <a
            [routerLink]="video.primaryAssoc.routerLink"
            class="primary-color-text"
            >View All {{ video.primaryAssoc?.name }}</a
          >
        </div>
        <div class="social-bar row">
          <div class="col-8 video-info">
            <flo-author-date
              [firstName]="video.author.firstName"
              [lastName]="video.author.lastName"
              [date]="video.author.date"
            >
            </flo-author-date>
          </div>
        </div>
        <flo-video-player
          floScrollToElementOnNavigation
          channel="videos-page"
          [video]="video.source"
          [isAutoPlayed]="true"
          (played)="onPlayed(video.nextVideoId)"
        >
        </flo-video-player>
        <div class="content full-content">
          <div
            class="description"
            data-test="video-description"
            *ngIf="video.description"
            floDynamicContent
          >
            <p [innerHtml]="video.description | floSanitizeHtml"></p>
          </div>
        </div>
        <div class="pb-4" *ngIf="video.source.node?.tags">
          <flo-tags
            collectionTabUriPart="/video"
            [tags]="video.source.node.tags"
          ></flo-tags>
        </div>

      </section>
      <aside class="col-12 col-lg-4 px-3 px-xl-4 pt-0 pt-sm-2">
        <div class="px-xl-2">
          <div *ngIf="rightRailAdProps$ | async as rightRailAdProps" class="d-flex justify-content-center lazy-flex-container pt-4">
            <flo-lazy
              [componentConstructor]="AdComponent"
              [initialProps]="rightRailAdProps"
              [detectorHeight]="250"
              [detectorWidth]="300"
              [threshold]="0.25"
              (componentLoaded)="loadedAdsPush($event)"
            ></flo-lazy>
          </div>
        </div>
      </aside>
    </div>
  </div>
  <div class="stick-to-footer">
    <div *ngIf="adhesionAdProps$ | async as adhesionAdProps" class="adhesion-ad d-sm-none">
      <flo-lazy
        [componentConstructor]="AdComponent"
        [initialProps]="adhesionAdProps"
        (componentLoaded)="loadedAdsPush($event)"
      ></flo-lazy>
    </div>
  </div>
</main>
